<template>
  <div class="bohr-hydrogen-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>E_n = -13.6 / n² eV | hν = E_m - E_n$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- The Nucleus -->
          <circle cx="200" cy="120" r="6" fill="#ff4757" />
          <text x="192" y="110" fill="#ff4757" font-size="8">质子</text>

          <!-- Allowed Orbits -->
          <circle v-for="n in 3" :key="'orb'+n" cx="200" cy="120" :r="n * 35" fill="none" stroke="rgba(255,255,255,0.1)" stroke-dasharray="4" />
          <text v-for="n in 3" :key="'lbl'+n" :x="200 + n*35 + 5" y="120" fill="#888" font-size="8">n={{ n }}</text>

          <!-- The Electron -->
          <circle :cx="electronPos.x" :cy="electronPos.y" r="4" fill="#00d2ff">
             <animateTransform attributeName="transform" type="rotate" :from="`0 200 120`" :to="`360 200 120`" :dur="1/currentLevel + 's'" repeatCount="indefinite" />
          </circle>

          <!-- Photon (Emission/Absorption) -->
          <path v-if="transitioning" :d="photonPath" fill="none" stroke="#ffd700" stroke-width="2">
             <animate attributeName="stroke-dashoffset" from="200" to="0" dur="0.8s" repeatCount="1" />
          </path>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>当前能级 n = {{ currentLevel }}</label>
              <div class="value">能量 E = {{ (-13.6 / (currentLevel * currentLevel)).toFixed(2) }} eV</div>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row">
             <el-button type="primary" size="mini" @click="transition(1)">跳转到 n=1 (基态)</el-button>
             <el-button type="success" size="mini" @click="transition(2)">跳转到 n=2</el-button>
             <el-button type="warning" size="mini" @click="transition(3)">跳转到 n=3</el-button>
          </div>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>波尔模型指出电子只能在一些分立的**定态轨道**上运动，且不辐射能量。当电子在不同能级间**跃迁**时，会吸收或放出特定频率的**光子**。这一理论成功解释了氢原子光谱的离散性，标志着量子力学的诞生。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BohrHydrogenViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      currentLevel: 1,
      transitioning: false
    }
  },
  computed: {
    electronPos() {
       return { x: 200 + this.currentLevel * 35, y: 120 };
    },
    photonPath() {
       // Wave-like path flying in or out
       return "M 200 0 Q 210 20 190 40 Q 210 60 190 80 L 200 120";
    }
  },
  methods: {
    transition(n) {
      if (this.currentLevel === n) return;
      this.transitioning = true;
      setTimeout(() => {
         this.currentLevel = n;
         this.transitioning = false;
      }, 500);
    }
  }
}
</script>

<style scoped lang="scss">
.bohr-hydrogen-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(0, 210, 255, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
